import Cookies from 'js-cookie';

let BetterWms = null;
if (typeof window !== 'undefined' && typeof window.L !== 'undefined') {
    L.TileLayer.BetterWMS = L.TileLayer.WMS.extend({
        onAdd: function (map) {
            // Triggered when the layer is added to a map.
            //   Register a click listener, then do all the upstream WMS things
            L.TileLayer.WMS.prototype.onAdd.call(this, map);
            map.on('click', this.getFeatureInfo, this);
        },
        
        onRemove: function (map) {
            // Triggered when the layer is removed from a map.
            //   Unregister a click listener, then do all the upstream WMS things
            L.TileLayer.WMS.prototype.onRemove.call(this, map);
            map.off('click', this.getFeatureInfo, this);
        },
        
        getFeatureInfo: async function (evt) {
            // Make an AJAX request to the server and hope for the best
            if(this.getData) {
                let args = this.getFeatureInfoUrl(evt.latlng), showResults = L.Util.bind(this.showGetFeatureInfo, this);

                const resp = await fetch('/leaflet/wms-proxy/', {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: JSON.stringify({name: this.name, args: args}),
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRFToken': Cookies.get('csrftoken')
                    }
                })
        
                if(resp.ok) {
                    const data = await resp.json()
                    const xmlString = data.xmlString
        
                    const parser = new DOMParser();
                    const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
        
                    L.Util.bind(function (data, status, xhr) {
                        if(this.getData) {
                            this.getData(evt, data);
                        } else {
                            showResults(err, evt.latlng, data);
                        }
                    }, this)(xmlDoc, resp.status, null);
                } else {
                    console.error('Could not fetch data from WMS with name: ', this.name)
                }
            }
        },
        
        getFeatureInfoUrl: function (latlng) {
            // Construct a GetFeatureInfo request URL given a point
            var point = this._map.latLngToContainerPoint(latlng, this._map.getZoom()),
                size = this._map.getSize(),
                
                params = {
                    request: 'GetFeatureInfo',
                    service: 'WMS',
                    srs: 'EPSG:4326',
                    styles: this.wmsParams.styles,
                    transparent: this.wmsParams.transparent,
                    version: this.wmsParams.version,      
                    format: this.wmsParams.format,
                    bbox: this._map.getBounds().toBBoxString(),
                    height: size.y,
                    width: size.x,
                    layers: this.wmsParams.layers,
                    query_layers: this.wmsParams.layers,
                    info_format: 'text/xml'
                };
            
            params[params.version === '1.3.0' ? 'i' : 'x'] = Math.floor(point.x);
            params[params.version === '1.3.0' ? 'j' : 'y'] = Math.floor(point.y);
            
            return L.Util.getParamString(params, this._url, true);
        },
        
        showGetFeatureInfo: function (err, latlng, content) {
            if (err) { console.log(err); return; } // do nothing if there's an error
            
            // Otherwise show the content in a popup, or something.
            L.popup({ maxWidth: 800})
                .setLatLng(latlng)
                .setContent(content)
                .openOn(this._map);
        }
    });
    
    BetterWms = L.tileLayer.betterWms = function (url, options) {
        return new L.TileLayer.BetterWMS(url, options);  
    };
}

export default BetterWms;